module.exports = __webpack_public_path__ + "img/y-224.97c92ea7.png";